/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CalendarIcon = /*#__PURE__*/ createSvgIcon(
  'CalendarIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M4.5 18c-.412 0-.766-.15-1.06-.448A1.452 1.452 0 013 16.5v-11c0-.403.147-.753.44-1.052A1.433 1.433 0 014.5 4H6V2.75c0-.212.071-.39.214-.534A.72.72 0 016.746 2c.21 0 .39.072.535.216a.72.72 0 01.219.534V4h5V2.75c0-.212.072-.39.214-.534A.72.72 0 0113.246 2c.21 0 .39.072.535.216A.72.72 0 0114 2.75V4h1.5c.412 0 .766.15 1.06.448.293.299.44.65.44 1.052v11c0 .403-.147.753-.44 1.052A1.433 1.433 0 0115.5 18h-11zm0-1.5h11V9h-11v7.5zm0-9h11v-2h-11v2zm5.504 4.5a.736.736 0 01-.535-.214.714.714 0 01-.219-.532c0-.21.071-.39.214-.535a.714.714 0 01.532-.219c.21 0 .39.072.535.214.146.143.219.32.219.532 0 .21-.072.39-.214.535a.714.714 0 01-.532.219zm-3.25 0a.736.736 0 01-.535-.214.714.714 0 01-.219-.532c0-.21.071-.39.214-.535a.714.714 0 01.532-.219c.21 0 .39.072.535.214.146.143.219.32.219.532 0 .21-.071.39-.214.535a.714.714 0 01-.532.219zm6.5 0a.736.736 0 01-.535-.214.714.714 0 01-.219-.532c0-.21.072-.39.214-.535a.714.714 0 01.532-.219c.21 0 .39.072.535.214.146.143.219.32.219.532 0 .21-.072.39-.214.535a.714.714 0 01-.532.219zm-3.25 3a.736.736 0 01-.535-.214.714.714 0 01-.219-.532c0-.21.071-.39.214-.535a.714.714 0 01.532-.219c.21 0 .39.072.535.214.146.143.219.32.219.532 0 .21-.072.39-.214.535a.714.714 0 01-.532.219zm-3.25 0a.736.736 0 01-.535-.214.714.714 0 01-.219-.532c0-.21.071-.39.214-.535a.714.714 0 01.532-.219c.21 0 .39.072.535.214.146.143.219.32.219.532 0 .21-.071.39-.214.535a.714.714 0 01-.532.219zm6.5 0a.736.736 0 01-.535-.214.714.714 0 01-.219-.532c0-.21.072-.39.214-.535a.714.714 0 01.532-.219c.21 0 .39.072.535.214.146.143.219.32.219.532 0 .21-.072.39-.214.535a.714.714 0 01-.532.219z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CalendarIcon;
